import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/store/authStore';
import { API_BASE } from '@/apiConfig';
import { withCompany } from '@/lib/withCompany';
import type { ApiMachine, UserPermissions } from '@/types';

export function useApiMachines() {
  const token   = useAuthStore((s) => s.user?.token ?? null);
  const company = useAuthStore((s) => s.company);

  return useQuery({
    queryKey: ['machines', company],
    enabled:  !!token,
    queryFn: async () => {
      const res = await fetch(withCompany(`${API_BASE}/machines`, company), {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(`API ${res.status}`);
      return res.json() as Promise<ApiMachine[]>;
    },
  });
}

export function useUserPermissions() {
  const token = useAuthStore((s) => s.user?.token ?? null);
  return useQuery({
    queryKey: ['me'],
    enabled:  !!token,
    queryFn: async () => {
      const res = await fetch(`${API_BASE}/users/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) return null;
      return res.json() as Promise<UserPermissions | null>;
    },
  });
}
